// ----------------------------------------------------------------------
// App config. Vite exposes env vars as import.meta.env.VITE_* — the CRA
// original used process.env.REACT_APP_*.
// ----------------------------------------------------------------------

/** Base URL of the FastAPI backend (jobvictorybackend). */
export const HOST_API = import.meta.env.VITE_HOST_API ?? '';

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 56,
  MAIN_DESKTOP_HEIGHT: 60,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};
